import { cn } from '@/lib/utils'

import { StarIcon } from './StarIcon'
import { useStarsVariants } from '../../Theme'

type StarSize = 'xs' | 'sm' | 'default' | 'lg' | 'xl'

interface StarsProps {
  /** Number of filled stars (0-5) */
  totalStars: number
  /** Size variant from CVA config */
  size?: StarSize
  /** Legacy size prop (e.g., 'h-6 w-6') - use size variant instead */
  starSize?: string
  /** Additional container classes */
  className?: string
}

/**
 * Stars - Rating display component
 *
 * Uses CVA variants from UiProvider for consistent styling.
 * For click-to-rate input use StarRatingInput.
 */
export function Stars({ totalStars, size = 'default', starSize, className }: StarsProps) {
  const variants = useStarsVariants()
  const iconClass = variants.starIconVariants({ size: starSize ? undefined : size, interactive: false })

  return (
    <div
      className={cn(variants.starsContainerVariants({ variant: 'default' }), className)}
      aria-label={`Rating: ${totalStars} din 5 stele`}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={cn(iconClass, starSize)}>
          <StarIcon filled={i < totalStars} className="h-full w-full" />
        </span>
      ))}
    </div>
  )
}
